<script setup>
  import { ref } from 'vue'
  import { useRouter } from 'vue-router'
  import { useAuth } from '@/composables/useAuth'

  const router = useRouter()
  const email = ref()
  const password = ref()
  const { login, isLoading, errorMessage } = useAuth()

  const onSubmit = async () => {
    const success = await login(email.value, password.value)
    if (success) {
       router.push({
        name: 'me'
      })
    }
  }
</script>

<template>
 
  <div class="bg-gray-50 dark:bg-gray-900 text-gray-800 dark:text-gray-100 transition-colors duration-300">

    <div class="flex h-screen items-center justify-center">

      <section class="w-[80%] max-w-[400px] bg-white dark:bg-gray-800 p-8 rounded-lg shadow">
        <form 
          @submit.prevent="onSubmit" 
          class="space-y-4"
        >
          <div class="flex items-center gap-4">
            <img class="w-12" src="/img/icons/favicon.svg"/>
            <h2 class="text-3xl font-semibold">Ingresar a <span class="text-[#ff642e]">Menui</span></h2>
          </div>
          <div class="flex flex-col gap-4">
            <input 
              type="text"
              class="rounded p-2 outline-0 shadow-sm text-black" 
              placeholder="Correo electrónico" 
              v-model="email"
            />
            <input 
              type="password"
              class="rounded p-2 outline-0 shadow-sm text-black" 
              placeholder="Contraseña" 
              v-model="password"
            />
            <button 
              type="submit" 
              class="rounded p-2 outline-0 shadow-sm bg-[#ff642e] text-white disabled:opacity-80"
              :disabled="isLoading"
            >
              {{ isLoading ? 'Cargando...' : 'Ingresar' }}
            </button>
            <p v-if="errorMessage" class="text-center text-xs">{{ errorMessage }}</p>
          </div>
        </form>
      </section>

    </div>

  </div>

</template>


